module.exports = __webpack_public_path__ + "img/default_image.b1399fee.png";